import { useConversationStore } from '../stores/conversationStore';
import { updateConversationDateLastAccessed } from '../api/conversations';


export const useConversationDateLastAccessed = (conversationID: string) => {
    const conversationStore = useConversationStore();

    const updateDateLastAccessed = () => {
        conversationStore.updateConversationDateLastAccessed(conversationID);
        updateConversationDateLastAccessed(conversationID)
            .catch((error) => {
                console.error('Failed to update conversation date last accessed:', error);
            });
    };


    return {
        updateDateLastAccessed,
    };
}
